{
  "DeleteReminder": "Supprimer le rappel",
  "EditReminder": "Modifier le rappel",
  "RemindMe15Min": "Me le rappeler dans 15 minutes",
  "RemindMe5Min": "Me le rappeler dans 5 minutes",
  "RemindMe60Min": "Me le rappeler dans une heure",
  "RemindMeTomorrow": "Me le rappeler demain",
  "SetReminder": "Rappel défini pour {formattedReminderTime}",
  "Snooze": "Répéter"
}
